(() => {
  'use strict';

  const finder = document.querySelector('.db-routine-finder');
  const form = finder?.querySelector('[data-db-routine-form]');
  const result = finder?.querySelector('[data-db-routine-result]');
  if (!finder || !form || !result) return;

  let stock = {};
  try {
    stock = JSON.parse(finder.querySelector('[data-db-finder-routines]')?.textContent || '{}') || {};
  } catch (error) {
    stock = {};
  }

  /* What each routine is built around, and what the bigger sizes add. spf = first size index that includes sunscreen (-1 = none). */
  const info = {
    'bright-glow-routine': {
      built: 'vitamin C, niacinamide and black rice for a brighter, more even-looking tone, finished with a cushiony hyaluronic cream',
      sizes: ['4 full-size products', 'the 4 steps + Abib SPF50+ sunstick', 'everything in Essentials + COSRX Snail 96 essence + Torriden sheet mask'],
      spf: 1, vitc: true
    },
    'soothe-hydrate-routine': {
      built: 'centella, heartleaf and hyaluronic acid to calm redness and quench tight-feeling skin, sealed in with a cushiony snail cream',
      sizes: ['4 full-size products', 'the 4 steps + Beauty of Joseon Relief Sun SPF50+', 'everything in Essentials + Abib Jericho Rose eye patches'],
      spf: 1
    },
    'overnight-plump-routine': {
      built: 'peptides, a deep-hydration Dokdo ampoule and the cult Laneige Water Sleeping Mask, so skin looks plump and rested by morning',
      sizes: ['4 full-size products', 'the 4 steps + Abib PDRN eye patches', 'everything in Essentials + Dr.Melaxin Aqua Ion toner + Torriden sheet mask'],
      spf: -1
    },
    'glow-routine': {
      built: 'a vitamin C toner, a dewy PDRN mist and the Laneige Water Sleeping Mask for a lit-from-within, glass-skin glow',
      sizes: ['4 full-size products', 'the 4 steps + Isntree Hyaluronic Acid sun serum SPF50', 'everything in Essentials + SKIN1004 cleansing oil + Abib eye patches'],
      spf: 1, vitc: true
    },
    'clear-skin-routine': {
      built: 'a salicylic acid cleanser, brightening capsules and a light snail cream that clear, calm and fade the look of post-blemish marks without stripping',
      sizes: ['4 full-size products', 'the 4 steps + SKIN1004 Hyalu-Cica sun serum SPF50+', 'everything in Essentials + Abib heartleaf spot pads + Torriden cica serum'],
      spf: 1, bha: true
    },
    'bounce-smooth-routine': {
      built: 'fermented essences and a silky royal cream for smoother texture and bouncier-looking skin',
      sizes: ['4 full-size products', 'the 4 steps + Beauty of Joseon Relief Sun SPF50+', 'everything in Essentials + Abib PDRN eye patches + Arencia vitamin C booster'],
      spf: 1
    },
    'dark-marks-even-tone-routine': {
      built: 'vitamin C, niacinamide + TXA and a zero-white-cast SPF50 to fade the look of dark marks the gentle way',
      sizes: ['4 full-size products, SPF included', 'the 4 steps + Medicube Collagen Jelly Cream', 'everything in Essentials + Anua azelaic acid serum'],
      spf: 0, vitc: true
    }
  };

  const skinWords = { dry: 'dry', oily: 'oily', combination: 'combination', normal: 'normal' };
  const sensWords = { yes: ' that reacts easily', sometimes: ' that can be a little sensitive', rarely: '' };
  const wishWords = {
    hydrate: 'juicy, hydrated skin',
    glow: 'a glass-skin glow',
    bright: 'a brighter, more even tone',
    clear: 'clearer-looking skin',
    texture: 'smoother-looking pores and texture',
    firm: 'firmer, bouncier-looking skin',
    calm: 'calmer, happier skin'
  };
  const skinTips = {
    dry: 'Dry skin tip: pat each step onto slightly damp skin and never skip the cream.',
    oily: 'Oily skin tip: a thin layer of each step is plenty. Hydration actually helps balance shine.',
    combination: 'Combination skin tip: go lighter on your T-zone and a little richer on drier cheeks.',
    normal: 'Normal skin tip: follow every step as written and enjoy the glow.'
  };

  /* Best match first; the quiz picks the first routine that's in stock. */
  function preferences(a) {
    const oilyish = a.skin === 'oily' || a.skin === 'combination';
    const reactive = a.sens === 'yes';
    switch (a.goal) {
      case 'calm':
        return ['soothe-hydrate-routine', 'overnight-plump-routine'];
      case 'hydrate':
        return reactive || oilyish
          ? ['soothe-hydrate-routine', 'overnight-plump-routine']
          : ['overnight-plump-routine', 'soothe-hydrate-routine'];
      case 'glow':
        if (reactive) return ['soothe-hydrate-routine', 'glow-routine', 'overnight-plump-routine'];
        return a.skin === 'dry'
          ? ['glow-routine', 'overnight-plump-routine', 'bright-glow-routine']
          : ['glow-routine', 'bright-glow-routine', 'overnight-plump-routine'];
      case 'bright':
        return ['bright-glow-routine', 'dark-marks-even-tone-routine', 'glow-routine', 'soothe-hydrate-routine'];
      case 'clear':
        return reactive
          ? ['soothe-hydrate-routine', 'clear-skin-routine']
          : ['clear-skin-routine', 'soothe-hydrate-routine'];
      case 'texture':
        if (reactive) return ['bounce-smooth-routine', 'soothe-hydrate-routine'];
        return oilyish
          ? ['clear-skin-routine', 'bounce-smooth-routine', 'bright-glow-routine']
          : ['bounce-smooth-routine', 'overnight-plump-routine', 'bright-glow-routine'];
      case 'firm':
        return ['overnight-plump-routine', 'bounce-smooth-routine'];
      default:
        return ['soothe-hydrate-routine'];
    }
  }

  function choose(a) {
    const list = preferences(a);
    const ideal = list.find((h) => stock[h]) || null;
    const pick = list.find((h) => stock[h] && stock[h].available) || null;
    return { ideal, pick };
  }

  /* ---------- Step-by-step flow (falls back to one long form without JS) ---------- */
  const steps = Array.from(form.querySelectorAll('[data-db-quiz-step]'));
  const progress = form.querySelector('[data-db-quiz-progress]');
  const count = form.querySelector('[data-db-quiz-count]');
  const bar = form.querySelector('[data-db-quiz-bar]');
  const back = form.querySelector('[data-db-quiz-back]');
  const next = form.querySelector('[data-db-quiz-next]');
  const submit = form.querySelector('[data-db-quiz-submit]');
  let current = 0;
  let pointerPick = false;

  const answered = (step) => !!step.querySelector('input:checked');

  function show(index, focus) {
    current = Math.max(0, Math.min(index, steps.length - 1));
    steps.forEach((step, i) => { step.hidden = i !== current; });
    const last = current === steps.length - 1;
    if (progress) progress.hidden = false;
    if (count) count.textContent = 'Question ' + (current + 1) + ' of ' + steps.length;
    if (bar) bar.style.width = ((current + 1) / steps.length) * 100 + '%';
    if (back) back.hidden = current === 0;
    if (next) { next.hidden = last; next.disabled = !answered(steps[current]); }
    if (submit) { submit.hidden = !last; submit.disabled = !answered(steps[current]); }
    if (focus) {
      const target = steps[current].querySelector('input:checked') || steps[current].querySelector('input');
      target?.focus({ preventScroll: true });
    }
    if (form.getBoundingClientRect().top < 0) form.scrollIntoView({ behavior: 'smooth', block: 'start' });
  }

  if (steps.length) {
    finder.classList.add('is-stepped');
    show(0, false);

    form.addEventListener('pointerdown', () => { pointerPick = true; });
    form.addEventListener('keydown', () => { pointerPick = false; });

    form.addEventListener('change', (event) => {
      if (event.target?.type !== 'radio') return;
      const last = current === steps.length - 1;
      if (next) next.disabled = false;
      if (submit && last) submit.disabled = false;
      if (!pointerPick) return; /* keyboard users move on with the Next button */
      window.setTimeout(() => {
        if (last) {
          if (typeof form.requestSubmit === 'function') form.requestSubmit(); else submit?.click();
        } else {
          show(current + 1, false);
        }
      }, 280);
    });

    next?.addEventListener('click', () => { if (answered(steps[current])) show(current + 1, true); });
    back?.addEventListener('click', () => show(current - 1, true));
  }

  /* ---------- Email capture ---------- */
  const emailBox = finder.querySelector('[data-db-quiz-email]');
  const showEmail = () => { if (emailBox) emailBox.hidden = false; };
  if (emailBox && (/customer_posted=true/.test(window.location.search) || emailBox.querySelector('.form-message--error'))) {
    showEmail();
    emailBox.scrollIntoView({ block: 'center' });
  }

  /* ---------- Result ---------- */
  form.addEventListener('submit', (event) => {
    event.preventDefault();
    const missing = steps.findIndex((step) => !answered(step));
    if (missing !== -1) { show(missing, true); form.reportValidity(); return; }

    const a = Object.fromEntries(new FormData(form).entries());
    const { ideal, pick } = choose(a);
    const titleEl = result.querySelector('[data-db-result-title]');
    const sizeEl = result.querySelector('[data-db-result-size]');
    const reasonEl = result.querySelector('[data-db-result-reason]');
    const tipsEl = result.querySelector('[data-db-result-tips]');
    const noteEl = result.querySelector('[data-db-result-note]');
    const img = result.querySelector('[data-db-result-img]');
    const link = result.querySelector('[data-db-result-link]');
    const addForm = result.querySelector('[data-db-result-add]');
    const addId = result.querySelector('[data-db-result-variant]');
    const addBtn = result.querySelector('[data-db-result-add-btn]');

    const tags = ['newsletter', 'skin-quiz', 'quiz-' + a.goal, 'quiz-skin-' + a.skin, 'quiz-sens-' + a.sens];

    if (!pick) {
      titleEl.textContent = 'Our routines are restocking';
      sizeEl.textContent = '';
      reasonEl.textContent = 'Every routine that fits your answers is restocking right now. Browse what\'s in stock, or leave your email below and we\'ll let you know.';
      tipsEl.innerHTML = '';
      noteEl.hidden = true;
      if (img) img.hidden = true;
      if (addForm) addForm.hidden = true;
      link.href = finder.dataset.urlDirectory || '/collections/all';
      link.textContent = 'Browse all routines ↗';
    } else {
      const r = stock[pick];
      const meta = info[pick] || { built: '', sizes: [], spf: -1 };
      let size = parseInt(a.size, 10) || 0;
      if (!r.variants[size] || !r.variants[size].available) {
        const fallback = r.variants.findIndex((v) => v.available);
        size = fallback === -1 ? 0 : fallback;
      }
      const variant = r.variants[size];

      titleEl.textContent = r.title;
      sizeEl.innerHTML = '';
      const sizeName = document.createElement('strong');
      sizeName.textContent = variant.title + ' · ' + variant.price;
      sizeEl.appendChild(sizeName);
      if (meta.sizes[size]) {
        const sizeInfo = document.createElement('small');
        sizeInfo.textContent = 'Includes ' + meta.sizes[size];
        sizeEl.appendChild(sizeInfo);
      }

      reasonEl.textContent = 'Because you have ' + skinWords[a.skin] + ' skin' + sensWords[a.sens] +
        ' and want ' + wishWords[a.goal] + ', we matched you with the ' + r.title + '. It\'s built around ' + meta.built + '.';

      const tips = [skinTips[a.skin]];
      if (a.sens !== 'rarely') {
        if (meta.vitc) tips.push('Sensitive skin tip: use the vitamin C step every other day for the first week, then build up.');
        else if (meta.bha) tips.push('Sensitive skin tip: start the salicylic acid cleanser once a day and build up slowly.');
        else tips.push(a.sens === 'yes'
          ? 'Sensitive skin tip: patch test first and add one new product every few days.'
          : 'Add new products one at a time so you can see how your skin likes them.');
      }
      if (meta.spf === -1 || size < meta.spf) tips.push('Finish every morning with a sunscreen. This size does not include one, so use your own.');
      tipsEl.innerHTML = '';
      tips.forEach((t) => { const li = document.createElement('li'); li.textContent = t; tipsEl.appendChild(li); });

      if (ideal && ideal !== pick && stock[ideal]) {
        noteEl.innerHTML = '';
        noteEl.append('Your closest match for ' + wishWords[a.goal] + ' is our ');
        const a2 = document.createElement('a');
        a2.href = stock[ideal].url;
        a2.textContent = stock[ideal].title;
        noteEl.append(a2, ', which is restocking soon. Until then, this is the best in-stock routine for your skin.');
        noteEl.hidden = false;
      } else {
        noteEl.hidden = true;
      }

      if (img) {
        if (r.img) { img.src = r.img; img.alt = r.title; img.hidden = false; } else { img.hidden = true; }
      }
      if (addForm && addId && addBtn) {
        addId.value = variant.id;
        addBtn.textContent = 'Add ' + variant.title + ' to bag · ' + variant.price;
        addForm.hidden = !variant.available;
      }
      link.href = r.url + '?variant=' + variant.id;
      link.textContent = 'See the routine & how to use it ↗';
      tags.push('quiz-' + pick.replace(/-routine$/, ''));
    }

    const tagsInput = emailBox?.querySelector('[data-db-quiz-tags]');
    if (tagsInput) tagsInput.value = tags.join(',');
    form.hidden = true;
    result.hidden = false;
    showEmail();
    result.scrollIntoView({ behavior: 'smooth', block: 'start' });
    titleEl.setAttribute('tabindex', '-1');
    titleEl.focus({ preventScroll: true });
  });

  result.querySelector('[data-db-result-reset]')?.addEventListener('click', () => {
    result.hidden = true;
    form.hidden = false;
    if (steps.length) show(0, true);
  });
})();
